import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { tableConfig } from "../../../../../commons/table/tableConfig";
import { StyledResolucion } from "../../../../../styled/Prevencion";

const MedidasPreventivasTable = ({ data, handleOpenAddForm, handleDelete }) => {
    const medidasPreventivas = useSelector((state) => state.resolucion.medidasPreventivas.data);

    const columns = useMemo(() => [
        {
            accessorKey: "idMedidaPreventiva",
            header: "Descripción",
            Cell: ({ row }) => {
                const medida = medidasPreventivas.find((e) => e.id === row.original.idMedidaPreventiva);
                return medida?.nombre ?? "";
            },
            filterVariant: 'text',
            filterFn: (row, id, filterValue) => {
                const medida = medidasPreventivas.find((e) => e.id === row.original.idMedidaPreventiva);
                return medida?.nombre?.toLowerCase().includes(filterValue.toLowerCase());
            }
        },
    ], [medidasPreventivas]);

    const table = useMaterialReactTable({
        columns,
        data: data || [],
        enableRowActions: true,
        positionActionsColumn: "last",
        displayColumnDefOptions: {
            "mrt-row-actions": {
                header: "Operaciones",
                size: 100,
                muiTableHeadCellProps: {
                    sx: {
                        ...tableConfig.muiTableHeadCellProps?.sx,
                        justifyContent: 'center',
                    },
                }
            },
        },
        enableHiding: false,
        paginationDisplayMode: 'pages',
        initialState: {
            pagination: {
                pageSize: 3,
                pageIndex: 0,
            },
        },
        muiPaginationProps: {
            rowsPerPageOptions: [3, 5, 10, 20],
            labelRowsPerPage: "Filas por página:",
            getItemAriaLabel: (type) => {
                if (type === 'first') return 'ir a la primera página';
                if (type === 'last') return 'ir a la última página';
                if (type === 'next') return 'ir a la página siguiente';
                return 'ir a la página anterior';
            },
            labelDisplayedRows: ({ from, to, count }) => `${from}-${to} de ${count}`,
        },
        localization: {
            ...MRT_Localization_ES,
            noRecordsToDisplay: "No hay elementos que mostrar",
        },
        renderTopToolbarCustomActions: () => (
            <StyledResolucion.HeaderContainer>
                <StyledResolucion.TableTitle>
                    Medidas Preventivas
                </StyledResolucion.TableTitle>
            </StyledResolucion.HeaderContainer>
        ),
        renderRowActions: ({ row }) => (
            <Tooltip title="Eliminar medida">
                <IconButton
                    onClick={() => { handleDelete(row.original.idMedidaPreventiva) }}
                    color="info"
                >
                    <DeleteIcon />
                </IconButton>
            </Tooltip>
        ),
        renderBottomToolbarCustomActions: () => (
            <StyledResolucion.TableFooterButtonContainer>
                <Button
                    color="primary"
                    onClick={handleOpenAddForm}
                >
                    Agregar
                </Button>
            </StyledResolucion.TableFooterButtonContainer>
        ),
        enablePagination: true,
        enableColumnFilters: false,
        enableColumnActions: false,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        muiTableHeadCellProps: {
            sx: { ...tableConfig.muiTableHeadCellProps?.sx }
        },
        muiTableBodyRowProps: {
            sx: { ...tableConfig.muiTableBodyRowProps?.sx }
        },
    });

    return (
        <StyledResolucion.TableContainer>
            <MaterialReactTable table={table} />
        </StyledResolucion.TableContainer>
    );
};

export default MedidasPreventivasTable;